export default {
  props: {
    ordine: Object,
    icon: Boolean,
  },
  data() {
    return {
      menu: false,
      codice_ritiro: 0,
      loading: false,
      destinazione_sel: null
    };
  },
  created() {
    this.codice_ritiro = parseInt(this.ordine.ritiro_cod);
    if (this.ordine.destinazione) {
      this.destinazione_sel = this.ordine.destinazione.id;
    } else {
      this.destinazione_sel = null;
    }
  },
  computed: {
    ritiro() {
      switch (this.ordine.ritiro_cod) {
        case 1:
          return { text: "Consegna", color: "blue", cod: 1 };
        case 0:
          return { text: "Ritiro", color: "green", cod: 0 };
      }
      return { text: "err", color: "red" };
    },
    destinazioni() {
      return this.$store.getters.get_cliente_by_iva(this.ordine.iva)
        .destinazioni;
    },
  },
  watch: {},
  methods: {
    confirm(){
      this.confirm_type_change();
      this.confirm_destinazione_change();
      this.menu = false;
    },
    confirm_type_change() {
      this.loading = true;
      this.$store
        .dispatch("imposta_tipo_consegna", {
          id: this.ordine._id.$oid,
          tipo: this.codice_ritiro,
        })
        .then(() => {
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirm_destinazione_change() {
      this.loading = true;
      this.$store
        .dispatch("cambia_destinazione_ordine", {
          id_ordine: this.ordine._id.$oid,
          id_destinazione: this.destinazione_sel,
        })
        .then(() => {
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
